export default {
  state: {
    arr: [],
    token: '',
    isShow: false
  },
  getter: {
    arr: state => {
      return state.arr;
    },
    token: state => {
      return state.token
    }
  },
  mutations: {
    arr(state, arr) {
      state.arr = arr;
    },
    token(state, token) {
      state.token = token;
    },
    isShow(state, isShow) {
      state.isShow = isShow;
    }
  },
  action: {}
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js